<template>
  <div v-if="isInit" class="h-full" :class="{ 'bg-gray-300': isIDP, 'min-h-screen': isIDP }">
    <IDPLayout v-if="isIDP" />
    <RedesignLayout v-else-if="isRedesign" />
    <PlanInfoLayout v-else-if="isVbUpgrade"
      :planTitle="planTitle"
      :planSubtitle="planSubtitle"
      :planFeatures="planFeatures"
    />
    <PlanInfoLayout v-else-if="isOot"
      :planTitle="planTitle"
      :planSubtitle="planSubtitle"
      :planFeatures="planFeatures"
    />
    <SSOLayout v-else />

    <ActionDialog
      :value="isInternalError"
      :title="globalErrorMsg.common"
      :message="globalErrorMsg.tryLater"
      :buttonText="lang.labelOK"
      @close="closeDialog"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import IDPLayout from './sub/idpLayout.vue';
import SSOLayout from './sub/ssoLayout.vue';
import PlanInfoLayout from './sub/planInfoLayout.vue';
import RedesignLayout from './redesign/RedesignLayout.vue';
import ActionDialog from '@/components/ActionDialog.vue';

export default {
  name: 'MainLayout',
  components: {
    IDPLayout,
    SSOLayout,
    PlanInfoLayout,
    RedesignLayout,
    ActionDialog,
  },
  computed: {
    ...mapState(['isInit', 'clientId', 'loginFrom', 'isInternalError']),
    ...mapState('auth', ['uiMode']),
    ...mapState({
      globalErrorMsg: (state) => state.lang.error_msg,
      l10nVbUpgrade: (state) => state.lang.vbUpgrade,
      l10nOot: (state) => state.lang.oot,
    }),
    ...mapState('auth', ['lang']),
    isIDP() {
      return this.clientId?.includes('IDP');
    },
    isRedesign() {
      return this.uiMode === 'redesign';
    },
    isVbUpgrade() {
      return this.loginFrom && this.loginFrom === 'upgrade_vb_myaccount';
    },
    isOot() {
      return this.loginFrom && this.loginFrom === 'activate_oot_activation';
    },
    planTitle() {
      if (this.isVbUpgrade) {
        return this.l10nVbUpgrade.title;
      }

      if (this.isOot) {
        return this.l10nOot.title;
      }

      return '';
    },
    planSubtitle() {
      if (this.isVbUpgrade) {
        let sssName =
        this.userLang === 'ja-JP'
          ? 'ウイルスバスター トータルセキュリティ'
          : 'Virus Buster Total Security';
        return this.l10nVbUpgrade.subtitle.replace('%SSS_Name%', sssName);
      }

      if (this.isOot) {
        return this.l10nOot.subtitle;
      }

      return '';
    },
    planFeatures() {
      if (this.isVbUpgrade) {
        return [
          this.l10nVbUpgrade.feature_1,
          this.l10nVbUpgrade.feature_2,
          this.l10nVbUpgrade.feature_3,
          this.l10nVbUpgrade.feature_4
        ];
      }

      if (this.isOot) {
        return [
          this.l10nOot.feature_1,
          this.l10nOot.feature_2,
          this.l10nOot.feature_3,
          this.l10nOot.feature_4
        ];
      }

      return [];
    },
  },
  methods: {
    ...mapActions(['triggerEvent', 'setInternalError']),
    closeDialog() {
      this.triggerEvent({ eventName: 'CloseInternalErrorDialog' });
      this.setInternalError(false);
    },
  },
};
</script>

<style lang="sass" scoped>
.form-card
  max-width: 480px
  padding: 40px
  border-radius: 16px

  @media (max-width: 720px)
    padding: 24px

/* mini browser header */
.mini-browser
  width: 800px
  height: 600px
  border-radius: 8px
  box-shadow: 0 2px 12px rgba(0,0,0,.25)
  overflow: hidden

.mini-browser-header
  background: rgba(250, 250, 250, 0.85)
  box-shadow: inset 0px -1px 0px #C9C9C9
  padding: 9px 8px 10px 16px
  font-size: 14px
  line-height: 19px
  color: #333

.mini-browser-content
  height: 557px
  overflow: scroll
  overflow-x: hidden

.btn-close
  padding-left: 8px
  border-left: 1px solid rgba(0, 0, 0, 0.15)
</style>
